import { PushNotifications } from '@capacitor/push-notifications';
import type { HttpClient } from '@project-types/http-client';
import type VueRouter from 'vue-router';

export const useCapacitorPushNotifications = (http?: HttpClient, router?: VueRouter) => {
  const addListeners = async () => {
    await PushNotifications.addListener('registration', async token => {
      console.info('Registration token: ', token.value);
      if (http) {
        try {
          await http.post('/v1/webuser/registerPushToken', { ['device_push_token']: token.value });
        } catch (err) {
          console.error('Failed to register push token with backend:', err);
        }
      }
    });

    await PushNotifications.addListener('registrationError', err => {
      console.error('Registration error: ', err.error);
    });

    await PushNotifications.addListener('pushNotificationReceived', notification => {
      console.log('Push notification received: ', notification);
    });

    await PushNotifications.addListener('pushNotificationActionPerformed', notification => {
      const data = notification.notification.data;
      if (router && data?.kind === 'url' && data?.url) {
        try {
          const { pathname, search } = new URL(data.url);
          router.push({ path: pathname + search }).catch(err2 => console.warn('Push nav:', err2));
        } catch (err) {
          console.error('Push notification navigation failed:', err);
        }
      }
    });
  };

  const initPushNotifications = async () => {
    let permStatus = await PushNotifications.checkPermissions();

    if (permStatus.receive === 'prompt' || permStatus.receive === 'prompt-with-rationale') {
      try {
        permStatus = await PushNotifications.requestPermissions();
        console.log('requestPermissions result:', permStatus.receive);
      } catch (err) {
        console.error('requestPermissions THREW:', err);
        return false;
      }
    }

    if (permStatus.receive !== 'granted') {
      return false;
    }

    await addListeners();
    await PushNotifications.register();
    return true;
  };

  return { initPushNotifications };
};
